/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * PositiveIcon Icon
 * @author Anuja Gaikwad
 * @file PositiveIcon.jsx
 */

import React from 'react';
import { SvgIcon } from '@mui/material';

function PositiveIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 18 18">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18ZM8.46894 13.0145L13.3322 6.06698C13.6252 5.64846 13.5234 5.0717 13.1049 4.77874C12.6864 4.48578 12.1096 4.58756 11.8167 5.00607L7.59429 11.038L5.90629 9.24452C5.55616 8.87251 4.97075 8.85476 4.59874 9.20489C4.22673 9.55502 4.20899 10.1404 4.55912 10.5124L7.02643 13.134C7.3504 13.4782 7.87582 13.5191 8.24723 13.2459C8.31126 13.2065 8.37493 13.1441 8.44077 13.0542C8.45055 13.0412 8.45994 13.028 8.46894 13.0145Z"
        fill="#006632"
      />
    </SvgIcon>
  );
}
export default PositiveIcon;

